export const setCookiesAccepted = (): void => {
  const currentDate = new Date()
  const expiryDate = new Date(currentDate.setMonth(currentDate.getMonth() + 36)).toUTCString()
  document.cookie = `cookie-banner=accept; path=/; expires=${expiryDate}; samesite=strict;`
}
